module.exports = __webpack_public_path__ + "static/media/lv.54429909.jpg";